import { Icon56MoneyTransferOutline } from "@vkontakte/icons";
import { UIButton } from "../../UIButton/UIButton";
import s from "./style.module.scss";
import { CloseButton } from "../../CloseButton/CloseButton";
interface GarantyModalProps {
  closeModal: () => void;
}
export const GarantyModal = (props: GarantyModalProps) => {
  const { closeModal } = props;
  return (
    <div className={s.wrapper}>
      <CloseButton onClose={closeModal} />
      <Icon56MoneyTransferOutline className={s.icons} />
      <p className={s.title}>Гарантия возврата, если <br /> что-то пойдет не так</p>
      <p className={s.description}>
        Оплата исполнителю после приема работы. <br />
        Возврат оплаты, если работа не сделана,
        <br /> нарушены сроки или не выполнены
        <br /> договоренности.
      </p>
      <UIButton
        fontType={"primary-2"}
        className={s.button}
        color="light-green-2"
        onClick={closeModal}
        size="thin"
      >
        Хорошо
      </UIButton>
    </div>
  );
};
